
import { datas } from '../../datas.js'
import HocDragAndDrop from '../../Hoc/DragAndDrop/index.jsx'
import './index.less'
import React from 'react'
window.datas = datas
console.log(React)

export default function Nav(props) {
  return (<div className='nav'>
    <div className='nav_main'>
      <ul className='main_box'>
        {datas.map((majorItems, index) => {
          return (<li className='majorItems' key={index}>
            <div className='majorItems_title'>
              <h3 className='title'>{majorItems.title}</h3>
            </div>
            <div className='majorItems_box'>
              {majorItems.data.map((xiaItem, index) => {
                return (
                  <div className='box_xiaItem' key={index}>
                    <HocDragAndDrop
                      pressAndHold={props.pressAndHold}
                      move={props.move}
                      up={props.up}
                      copyComp={xiaItem.navCopyComp}
                      ifon={xiaItem}
                      isCut={pulled(xiaItem, props.activeComps, props.beBasedOn)}
                    ><xiaItem.navComp isCut={pulled(xiaItem, props.activeComps)} {...xiaItem}></xiaItem.navComp></HocDragAndDrop>
                  </div>
                )
              })}
            </div>

          </li>)
        })}
      </ul>
    </div>
    {/* <div className='nav_bottom'>
      <div className='item'>
        <i className='item_icon'>
          <svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='report'><path d='M2.5 14.9231V3.07692C2.5 2.21538 2.71727 2 3.59 2H12.243C12.3873 2 12.58 2.08 12.6787 2.17868L15.3213 4.82132C15.4258 4.92584 15.5 5.10982 15.5 5.24529V14.9231C15.5 15.7846 15.2827 16 14.41 16H3.59C2.71727 16 2.5 15.7846 2.5 14.9231ZM5 5.5V6.75H10V5.5H5ZM5 8.5V9.75H13V8.5H5ZM5 11.5V12.75H13V11.5H5Z' fill-rule='evenodd'></path></svg>
        </i>
        <span className='item_text'>使用手册</span>
      </div>
      <div className='item'>
        <span className='item_text'>快速了解</span>
      </div>
      <div className='item'>
        <span className='item_text'>快捷键</span>
      </div>
    </div> */}
  </div>)
}

function pulled(item, activeComps, beBasedOn) {
  if (!item.contentComp) {
    return false
  }
  if (item.name.startsWith('novelIfon_')) {
    for (let i = 0; i < activeComps.length; i++) {
      if (activeComps[i].startsWith('novelIfon_')) {
        return false
      }
    }
    return true
  }

  if (item.name === 'basics_OfficialAccount_comp' && beBasedOn === 'component') {
    return false
  }

  if (item.name === 'marketing_suspension_comp' && activeComps.includes('marketing_suspension_comp')) {
    return false
  }

  return true
}

